import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetDataService {
  private messageSource = new BehaviorSubject(false);
  currentMessage = this.messageSource.asObservable();
  
  constructor() { }
  
  set(message: boolean) {
  this.messageSource.next(message)
  }
}
